import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateBlocoModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/blocos',
    nameForTitle: 'Bloco',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateBlocoModal
